import { useEffect, useState } from "react";
import * as S from "./styles";
import { getTranslateByKey } from "@/main/services/utils";
import SecondaryButton from "@/main/components/shared/button/secondaryButton";
import BoxGrid from "@/main/components/shared/boxGrid/boxGrid";
import KOGPaginationGrid from "@/main/components/shared/paginationGrid/paginationGrid";
import { TableRow, TableCell } from "@mui/material";
import { AnnouncementCompaniesResponse } from "@/main/models/response/announcementResponse";
import { announcementApi } from "@/main/api";
import { AnnouncementCompaniesRequest } from "@/main/models/request/announcementRequest";
import { PaginationEnum } from "@/main/services/enum/PaginationEnum";
import { ModalCompaniesWillSee } from "./companiesWillSeeModal/companiesWillSeeModal";
import { ContainerSection } from "@/main/components/shared/styles";
import { isNil } from "lodash";
import { KeyValue } from "@/main/models/common";
import LoadingComponent from "@/main/components/shared/loading/loadingComponent";

const ID_SCROLLABLE_TARGET = "id-scrollable-target-announcement-companiesWillSee";

interface Props {
	guidAnnouncement: string;
	companiesSelected: string[];
	setCompaniesSelected: (guids: string[]) => void;
	watcherWhoCanSee: KeyValue[] | null;
	watcherCompany: KeyValue | null;
	disabled: boolean;
}

export function AnnouncementRegisterCompaniesWillSee({
	guidAnnouncement,
	companiesSelected,
	setCompaniesSelected,
	watcherWhoCanSee,
	watcherCompany,
	disabled,
}: Props) {
	const [openModalCompaniesWillSee, setOpenModalCompaniesWillSee] = useState<boolean>(false);
	const [totalRecords, setTotalRecords] = useState<number>(0);
	const [dataGrid, setDataGrid] = useState<AnnouncementCompaniesResponse[]>([]);
	const [formFilters, setFormFilters] = useState<any | null>(null);
	const [isLoadingGrid, setIsLoadingGrid] = useState<boolean>(false);

	const rowHeaders = [
		getTranslateByKey("information.rfc"),
		getTranslateByKey("information.company"),
		getTranslateByKey("information.companyType"),
		getTranslateByKey("information.userDateTime"),
		getTranslateByKey("information.actions"),
	];

	useEffect(() => {
		if (formFilters == null) {
			const baseFilter: AnnouncementCompaniesRequest = {
				guidAnnouncement,
				pageIndex: PaginationEnum.PageIndexIntial,
				pageSize: PaginationEnum.PageSize10,
			};

			setDataGrid([]);
			setFormFilters(baseFilter);
		}
	}, [formFilters]);

	useEffect(() => {
		if (dataGrid.length > 0 && companiesSelected.length == 0) {
			handleReloadDataGrid();
		}
	}, [companiesSelected]);

	async function fetchData(request: any) {
		return announcementApi.getDetailCompaniesWillSee(request).then((response) => response.data);
	}

	function handleDeleteCompany(guidCompany: string) {
		setCompaniesSelected([...companiesSelected, guidCompany]);
	}

	function handleCloseModalCompaniesWillSee(refresh = false) {
		setOpenModalCompaniesWillSee(false);

		if (refresh) {
			handleReloadDataGrid();
		}
	}

	async function handleReloadDataGrid() {
		setIsLoadingGrid(true);

		const result = await fetchData(formFilters);

		setDataGrid(result.results);
		setTotalRecords(result.totalNumberOfRecords);
		setIsLoadingGrid(false);
	}

	return (
		<>
			<ContainerSection style={{ marginTop: "1rem" }}>
				<S.ContainerTitle>
					<S.HeaderTextSession>{getTranslateByKey("information.companiesWhoWillSee")}</S.HeaderTextSession>
					<SecondaryButton
						style={{
							padding: ".2rem .8rem",
							marginTop: ".6rem",
							marginLeft: "1rem",
						}}
						onClick={() => setOpenModalCompaniesWillSee(true)}
						id="id-register-button-addCompanies"
						disabled={disabled}
					>
						{getTranslateByKey("information.addCompanies")}
					</SecondaryButton>
				</S.ContainerTitle>

				<S.ContainerScroll id={ID_SCROLLABLE_TARGET}>
					{isLoadingGrid && <LoadingComponent />}
					<KOGPaginationGrid
						idScrollableTarget={ID_SCROLLABLE_TARGET}
						showTitleResults={false}
						totalRecords={totalRecords}
						setTotalRecords={setTotalRecords}
						dataGrid={dataGrid}
						formFilters={formFilters}
						setDataGrid={setDataGrid}
						fetchMore={fetchData}
					>
						<BoxGrid rowHeaders={rowHeaders} marginCustom="0px">
							{dataGrid.map((supplierRelation) => (
								<TableRow key={supplierRelation.companyRegistrationNumber}>
									<TableCell width="10%">{supplierRelation.companyRegistrationNumber}</TableCell>
									<TableCell width="15%">{supplierRelation.companyName}</TableCell>
									<TableCell width="25%">{supplierRelation.companyTypeName}</TableCell>
									<TableCell width="25%">
										{`${supplierRelation.userCreatorName} - ${supplierRelation.creationDateFormatted}`}
									</TableCell>
									<TableCell width="1%" align="center">
										{!companiesSelected.some((guid) => guid === supplierRelation.guidCompany) && !disabled && (
											<S.IconClose
												id={"id-announcement-register-delete-company-button"}
												onClick={() => handleDeleteCompany(supplierRelation.guidCompany)}
											/>
										)}
									</TableCell>
								</TableRow>
							))}
						</BoxGrid>
					</KOGPaginationGrid>
				</S.ContainerScroll>
			</ContainerSection>

			<ModalCompaniesWillSee
				guidAnnouncement={guidAnnouncement}
				closeModal={handleCloseModalCompaniesWillSee}
				isOpenModal={openModalCompaniesWillSee}
				optionsCompanyType={isNil(watcherWhoCanSee) ? null : watcherWhoCanSee}
				guidCompanyAnnouncer={watcherCompany?.key ? String(watcherCompany.key) : ""}
			/>
		</>
	);
}
